module.exports = __webpack_public_path__ + "img/angle-left.88745697.svg";